<script>
import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import StarRating from 'vue-star-rating'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  name: 'profile-modal',
  data () {
    return {
      userid: '',
      sid: '',
      base_urls: BaseURL,
      profiledetails: [],
      profilesills: [],
      groupeddate: [],
      userInfo: [],
      scheduledetail: [],
      resultdata: [],
      feedbackdetails: [],
      feedbackdetailslength: 0,
      feedback_skills: [],
      feedback_skills_len: 0,
      postdatas: [],
      startdate: '',
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
    }
  },
  components: {
    StarRating,
    VueHtml2pdf
  },
  created () {
    this.userid = JSON.parse(localStorage.getItem('viewid'))
    this.selectpost = JSON.parse(localStorage.getItem('postId'))
    this.sid = JSON.parse(localStorage.getItem('sid'))
    this.getdata()
    this.getscheduledata()
    this.getresultdata()
  },
  mounted () {
    this.$root.$on('generate_result_pdf', (arg) => {
      console.log('dd')
      this.generateReport()
    })
  },
  methods: {
    generateReport () {
      this.$refs.html2Pdf.generatePdf()
    },
    SendMessageToParent () {
      this.$root.$emit('message_from_abc', this.selectpost)
    },
    groupBy (array, key) {
      const result = {}
      this.groupeddate = []
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
          // this.groupeddate.push(item);
        }
        result[item[key]].push(item)
      })
      this.groupeddate = result
      console.log(this.groupeddate)
      setTimeout(() => this.generateReport(), 2000)
    },
    getscheduledata () {
      const mainurl = '/dashboard/get_schedule_detail/web/' + this.sid
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.scheduledetail = response.data.scheduleList[0]
      }).catch(e => {
        console.log(e)
      })
    },
    getresultdata () {
      const mainurl = '/dashboard/get_schedule_feedback_details/web/' + this.sid
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.feedbackdetails = response.data.feedbackdetails[0]
        this.feedbackdetailslength = response.data.feedbackdetails.length
        if (this.feedbackdetailslength > 0) {
          this.feedback_skills = response.data.feedback_skills
          this.feedback_skills_len = response.data.feedback_skills.length
          this.active_name = this.feedback_skills[0]._id
        }
      }).catch(e => {
        console.log(e)
      })
    },
    getdata () {
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      const mainurl = '/dashboard/get_profile_detail/' + this.userid + '/' + this.selectpost + '/' + this.userInfo._id
      axios.get(`${this.base_urls}${mainurl}`, this.config).then(response => {
        this.profiledetails = response.data.profileDetail[0]
        this.profilesills = response.data.profileSkillList
        this.groupBy(response.data.availabilityDetails, 'startdate')
      }).catch(e => {
        console.log(e)
      })
    },
    onProgress (e) {
      console.log(e)
    },
    hasStartedGeneration (e) {
      console.log(e)
    },
    hasGenerated (e) {
      console.log(e)
    }
  }
}
</script>

<template>
   <vue-html2pdf
          :show-layout="false"
          :enable-download="true"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          :filename="scheduledetail.candidate_name"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          @progress="onProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf">
          <section slot="pdf-content" class="invoice">
            <section class="pdf-item" style="margin-top: 2px;">
            <div class="row">
              <div class="col-xs-12 p-1">
                <div class="user-panel page-header" style="background-color: #F5F5F5">
                  <div class="pull-left image">
                    <img src="../../assets/img/default.png" style="max-width: 60px;" class="img-circle" alt="User Image">
                  </div>
                  <div class="pull-left col-md-8">
                    <p class="cg" style="margin-bottom: auto;">{{scheduledetail.candidate_name}}</p>
                    <div class="f19 p-1">
                      {{profiledetails.designation}} | {{scheduledetail.candidate_email}}
                    </div>
                  </div>
                  <div class="col-md-2 tc">
                    <img src="../../assets/img/logo-black.png" style="max-width: 150px;">
                    <!-- <img v-if="feedbackdetails.eligible_for_this_position !='yes' && feedbackdetails.eligible_for_this_position !=''" src="../../assets/img/stamp.png" style="max-width: 80px;" class="img-circle">
                    <img v-if="feedbackdetails.eligible_for_this_position =='yes' && feedbackdetails.eligible_for_this_position !=''" src="../../assets/img/stamp-eligble.png" style="max-width: 80px;" class="img-circle"> -->
                  </div>
                </div>
              </div>
              <!-- /.col -->
            </div>
            <!-- info row -->
            <div class="row">
              <div class="col-sm-12">
                <div class="col-sm-6 p-1 f19"><strong>Interview Details</strong></div>
                <div class="col-sm-6 p-1 text-label"><div class="pull-right">Interview Status &nbsp;&nbsp;
                  <span v-if="feedbackdetails.interview_status =='Incomplete' || feedbackdetails.interview_status =='Incompleted'" class="cr">Incomplete</span>
                  <span v-if="feedbackdetails.interview_status =='Completed'" class="cg">Completed</span>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-sm-6 f14">
                <div class="col-sm-6 p-1 text-label">Interviewer Name</div>
                <div class="col-sm-6 p-1">{{profiledetails.first_name}} {{profiledetails.last_name}}</div>
                <div class="col-sm-6 mt-2 p-1 text-label">Interview Time</div>
                <div class="col-sm-6 mt-2 p-1">{{scheduledetail.schedule_start_time}} to {{scheduledetail.schedule_end_time}}</div>
                <div class="col-sm-6 mt-2 p-1 text-label">Interview Duration</div>
                <div class="col-sm-6 mt-2 p-1" v-if="scheduledetail.interview_duration">{{scheduledetail.interview_duration}}</div>
                <div class="col-sm-6 mt-2 p-1" v-if="!scheduledetail.interview_duration">NA</div>
              </div>
              <div class="col-sm-6">
                <div class="col-sm-5 text-label">Interview Date</div>
                <div class="col-sm-7 p-1">{{scheduledetail.schedule_date | formatDate}}</div>
                <div class="col-sm-6 mt-2 text-label">Mode of Interview</div>
                <div class="col-sm-6 mt-2 p-1">{{scheduledetail.job_interview_type}}</div>
              </div>
            <div class="row mt-2" v-if="feedbackdetails.interview_status == 'Incomplete' || feedbackdetails.interview_status == 'Incompleted'">
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <h5 style="font-weight: 600;">Reason</h5>
                  <hr class="c-hr">
                  <p>{{feedbackdetails.incomplete_reason_name}}</p>
                  <h5 style="font-weight: 600;">Comments</h5>
                  <hr class="c-hr">
                  <p>{{feedbackdetails.incomplete_reason_cmt}}</p>
                </div>
              </div>
            </div>
            </div>
            <div class="row mt-2" v-if="feedbackdetails.interview_status != 'Incomplete' && feedbackdetails.interview_status != 'Incompleted'">
              <div class="col-md-12 p-1 mt-2">
                <div class="col-md-12 t-head"><strong>Skill Details</strong></div>
              </div>
            </div>
            <div v-if="feedbackdetails.interview_status != 'Incomplete' && feedbackdetails.interview_status != 'Incompleted'">
            <div class="row mt-2" v-for="x in feedback_skills.slice(0, 3)" :key="x._id">
              <div class="col-md-12 mt-2">
                <div class="col-md-12 p-1 mt-2">
                  <strong>{{x.skill_name}}</strong>
                  <hr class="c-hr">
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Skill Rating</div>
                  <div class="col-md-9 p-1 mt-2"><div class="col-md-3 p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="x.skill_rating" read-only="true"></star-rating></div></div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Experience</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.experience">{{x.experience}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.experience">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Scenario / Program Concept</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.program_concept">{{x.program_concept}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.program_concept">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Logics</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.logics">{{x.logics}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.logics">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Development Tools</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.development_tools">{{x.development_tools}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.development_tools">--</div>
                </div>
              </div>
            </div>
            </div>
            <!-- <div class="absolute row mb-10">
              <hr class="hrfoeter">
              <div class="col-md-12">
                <div class="col-md-10">Page 1</div>
                <div class="col-md-2"><img src="../../assets/img/logo-black.png" style="max-width: 100px;"></div>
              </div>
            </div> -->
          </section>
          <div v-if="feedback_skills_len > 0 && feedbackdetails.interview_status != 'Incomplete' && feedbackdetails.interview_status != 'Incompleted'">
          <!-- <div v-if="feedback_skills_len > 3" class="html2pdf__page-break"/> -->
          <section v-if="feedback_skills_len > 3" class="pdf-item pdf-item2">
            <div class="row" v-for="x in feedback_skills.slice(3, 7)" :key="x._id">
              <div class="col-md-12 mt-2">
                <div class="col-md-12 p-1 mt-2">
                  <strong>{{x.skill_name}}</strong>
                  <hr class="c-hr">
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Skill Rating</div>
                  <div class="col-md-9 p-1 mt-2"><div class="col-md-3 p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="x.skill_rating" read-only="true"></star-rating></div></div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Experience</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.experience">{{x.experience}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.experience">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Scenario / Program Concept</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.program_concept">{{x.program_concept}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.program_concept">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Logics</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.logics">{{x.logics}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.logics">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Development Tools</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.development_tools">{{x.development_tools}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.development_tools">--</div>
                </div>
              </div>
            </div>
            <!-- <div class="absolute row">
              <hr>
              <div class="col-md-12">
                <div class="col-md-10">Page 2</div>
                <div class="col-md-2"><img src="../../assets/img/logo-black.png" style="max-width: 100px;"></div>
              </div>
            </div> -->
          </section>
          <div v-if="feedback_skills_len > 7" class="html2pdf__page-break"/>
          <section v-if="feedback_skills_len > 7" class="pdf-item pdf-item2">
            <div class="row" v-for="x in feedback_skills.slice(7, 11)" :key="x._id">
              <div class="col-md-12 mt-2">
                <div class="col-md-12 p-1 mt-2">
                  <strong>{{x.skill_name}}</strong>
                  <hr class="c-hr">
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Skill Rating</div>
                  <div class="col-md-9 p-1 mt-2"><div class="col-md-3 p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="x.skill_rating" read-only="true"></star-rating></div></div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Experience</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.experience">{{x.experience}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.experience">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Scenario / Program Concept</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.program_concept">{{x.program_concept}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.program_concept">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Logics</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.logics">{{x.logics}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.logics">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Development Tools</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.development_tools">{{x.development_tools}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.development_tools">--</div>
                </div>
              </div>
            </div>
            <!-- <div class="absolute row mb-10">
              <hr>
              <div class="col-md-12">
                <div class="col-md-10">Page 3</div>
                <div class="col-md-2"><img src="../../assets/img/logo-black.png" style="max-width: 100px;"></div>
              </div>
            </div> -->
          </section>
          <div v-if="feedback_skills_len > 11" class="html2pdf__page-break"/>
          <section v-if="feedback_skills_len > 11" class="pdf-item pdf-item2">
            <div class="row" v-for="x in feedback_skills.slice(11, 15)" :key="x._id">
              <div class="col-md-12 mt-2">
                <div class="col-md-12 p-1 mt-2">
                  <strong>{{x.skill_name}}</strong>
                  <hr class="c-hr">
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Skill Rating</div>
                  <div class="col-md-9 p-1 mt-2"><div class="col-md-3 p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="x.skill_rating" read-only="true"></star-rating></div></div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Experience</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.experience">{{x.experience}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.experience">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Scenario / Program Concept</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.program_concept">{{x.program_concept}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.program_concept">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Logics</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.logics">{{x.logics}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.logics">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Development Tools</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.development_tools">{{x.development_tools}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.development_tools">--</div>
                </div>
              </div>
            </div>
            <!-- <div class="absolute row mb-10">
              <hr>
              <div class="col-md-12">
                <div class="col-md-10">Page 4</div>
                <div class="col-md-2"><img src="../../assets/img/logo-black.png" style="max-width: 100px;"></div>
              </div>
            </div> -->
          </section>
          <div v-if="feedback_skills_len > 15" class="html2pdf__page-break"/>
          <section v-if="feedback_skills_len > 15" class="pdf-item pdf-item2">
            <div class="row" v-for="x in feedback_skills.slice(15, 20)" :key="x._id">
              <div class="col-md-12 mt-2">
                <div class="col-md-12 p-1 mt-2">
                  <strong>{{x.skill_name}}</strong>
                  <hr class="c-hr">
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Skill Rating</div>
                  <div class="col-md-9 p-1 mt-2"><div class="col-md-3 p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="x.skill_rating" read-only="true"></star-rating></div></div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Experience</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.experience">{{x.experience}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.experience">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Scenario / Program Concept</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.program_concept">{{x.program_concept}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.program_concept">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Logics</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.logics">{{x.logics}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.logics">--</div>
                </div>
                <div class="col-md-12 mt-2">
                  <div class="col-md-3 p-1 mt-2">Development Tools</div>
                  <div class="col-md-9 p-1 mt-2" v-if="x.development_tools">{{x.development_tools}}</div>
                <div class="col-md-9 p-1 mt-2" v-if="!x.development_tools">--</div>
                </div>
              </div>
            </div>
            <!-- <div class="absolute row mb-10">
              <hr>
              <div class="col-md-12">
                <div class="col-md-10">Page 5</div>
                <div class="col-md-2"><img src="../../assets/img/logo-black.png" style="max-width: 100px;"></div>
              </div>
            </div> -->
          </section>
          <!-- end page -->
          <div v-if="feedback_skills_len > 3" class="html2pdf__page-break"/>
          <section class="pdf-item pdf-item2">
            <div class="row mt-2">
              <div class="col-md-12 p-1 mt-2">
                <div class="col-md-12 t-head"><strong>Evaluation Details</strong></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="col-md-6 p-1 mt-2">Attention to details</div>
                <div class="col-md-6 p-1 mt-2"><div class="col-md-4 pull-right p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.attention" read-only="true"></star-rating></div></div>
              </div>
            </div>
            <hr class="c-hr">
            <div class="row">
              <div class="col-md-12">
                <div class="col-md-6 p-1 mt-2">Intrigity</div>
                <div class="col-md-6 p-1 mt-2"><div class="col-md-4 pull-right p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.intrigity" read-only="true"></star-rating></div></div>
              </div>
            </div>
            <hr class="c-hr">
            <div class="row">
              <div class="col-md-12">
                <div class="col-md-6 p-1 mt-2">Cooperation</div>
                <div class="col-md-6 p-1 mt-2"><div class="col-md-4 pull-right p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.cooperation" read-only="true"></star-rating></div></div>
              </div>
            </div>
            <hr class="c-hr">
            <div class="row">
              <div class="col-md-12">
                <div class="col-md-6 p-1 mt-2">Strees Tolerance</div>
                <div class="col-md-6 p-1 mt-2"><div class="col-md-4 pull-right p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.stress_tolerance" read-only="true"></star-rating></div></div>
              </div>
            </div>
            <hr class="c-hr">
            <div class="row">
              <div class="col-md-12">
                <div class="col-md-6 p-1 mt-2">Learning Ability</div>
                <div class="col-md-6 p-1 mt-2"><div class="col-md-4 pull-right p-1"><star-rating :show-rating="false" active-color="#5bad2b" v-bind:increment="0.5" v-bind:star-size="20" :rating="feedbackdetails.learning_ability" read-only="true"></star-rating></div></div>
              </div>
            </div>
            <hr class="c-hr">
            <div class="row mt-2">
              <div class="col-md-12 p-1 mt-2">
                <div class="col-md-12 t-head"><strong>Others</strong></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-2">
                <div class="col-md-6 p-1 mt-2">Window violation</div>
              </div>
              <div class="col-md-12">
                <span style="color:#C5C5C5">comments</span>
                <div class="col-md-12 p-1" v-if="feedbackdetails.window_violation_cmt != ''">{{feedbackdetails.window_violation_cmt}}</div>
                <div class="col-md-12 p-1" v-if="!feedbackdetails.window_violation_cmt">NA</div>
              </div>
            </div>
            <hr class="c-hr">
            <div class="row">
              <div class="col-md-12 mt-2">
                <div class="col-md-6 p-1 mt-2">Relevant Work Experience</div>
              </div>
              <div class="col-md-12">
                <span style="color:#C5C5C5">comments</span>
                <div class="col-md-12 p-1" v-if="feedbackdetails.work_experience_cmt != ''">{{feedbackdetails.work_experience_cmt}}</div>
                <div class="col-md-12 p-1" v-if="!feedbackdetails.work_experience_cmt">NA</div>
              </div>
            </div>
            <hr class="c-hr">
            <div class="row">
              <div class="col-md-12 mt-2">
                <div class="col-md-6 p-1 mt-2">Relevant Educational Background</div>
              </div>
              <div class="col-md-12">
                <span style="color:#C5C5C5">comments</span>
                <div class="col-md-12 p-1" v-if="feedbackdetails.edu_background_cmt != ''">{{feedbackdetails.edu_background_cmt}}</div>
                <div class="col-md-12 p-1" v-if="!feedbackdetails.edu_background_cmt">NA</div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12 p-1 mt-2">
                <div class="col-md-12 t-head"><strong>Interviewer Comments</strong></div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mt-2">
                <div class="col-md-12 p-1 mt-2" v-if="feedbackdetails.eligible_comments">{{feedbackdetails.eligible_comments}}</div>
                <div class="col-md-12 p-1 mt-2" v-if="!feedbackdetails.eligible_comments">NA</div>
              </div>
            </div>
            <div class="row">
              <div style="margin-left:15px">
                <h5><strong>Screenit score</strong></h5>
                <span v-for="item in 10" :key="item" v-bind:class="{'sit-score-active': item == feedbackdetails.sit_score || item < feedbackdetails.sit_score}"  class="sit-score">{{item}}</span>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12 mt-2">
                <div class="col-md-12 p-1 mt-2 tc" style="color: #AFAFAF">-- Thank You --</div>
              </div>
            </div>
            <!-- <div class="absolute row mb-10" style="margin-top:50px;">
              <hr class="hrfoeter">
              <div class="col-md-12">
                <div class="col-md-10" v-if="feedback_skills_len < 3">Page 2</div>
                <div class="col-md-10" v-if="feedback_skills_len > 3">Page 3</div>
                <div class="col-md-10" v-if="feedback_skills_len > 7">Page 4</div>
                <div class="col-md-10" v-if="feedback_skills_len > 11">Page 5</div>
                <div class="col-md-2"><img src="../../assets/img/logo-black.png" style="max-width: 100px;"></div>
              </div>
            </div> -->
          </section>
          </div>
          </section>
      </vue-html2pdf>
</template>
<style scoped>
.f19 {
  font-size: 14px;
}
.cg {
  color: #5bad2b;
}
.t-head {
  background-color: #F5F5F5;
  padding: 5px;
}
.c-hr {
  margin-top: 3px;
  margin-bottom: 14px;
}
.f12 {
  font-size: 12px;
}
.text-label {
  color: #919191;
}
.invoice {
  position: relative;
  background: #fff;
  border: 1px solid #f4f4f4;
  padding: 0px !important;
  margin: 0px 0px 0px 0px !important;
}
.page-header {
  margin: 0px 0 9px 0;
  font-size: 22px;
}
.content-wrapper {
  margin-left: 0px !important;
}
.cr {
  color: red;
}
.vue-html2pdf .pdf-preview {
  position: fixed;
  width: 85% !important;
  min-width: 600px;
  height: 100% !important;
  top: 30px !important;
  z-index: 9999999;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 5px;
  box-shadow: 0 0 10px #00000048;
}
section.content-wrapper {
  margin-left: 0px !important;
  margin-top: 0px !important;
  background-color: #fff !important;
}
.pdf-item2 {
  margin-top: 7% !important;
}
.sit-score {
  background-color: #f5f5f5;
  color: #333;
  padding: 10px 15px 10px 15px;
  margin-right: 5px;
}
.sit-score-active {
  background-color: #5bad2b !important;
  color: #fff !important;
  padding: 10px 15px 10px 15px;
  margin-right: 5px;
}
</style>
